<div class="assessment-text p-3">
  <p>{{ 'ASSESSMENTAPP.GUIDENESS_TEXT.intro' | translate }}</p>
  <p>{{ 'ASSESSMENTAPP.GUIDENESS_TEXT.purpose' | translate }}</p>
  <p>{{ 'ASSESSMENTAPP.GUIDENESS_TEXT.noRightAnswer' | translate }}</p>
  <p>{{ 'ASSESSMENTAPP.GUIDENESS_TEXT.camera' | translate }}</p>
  <p>{{ 'ASSESSMENTAPP.GUIDENESS_TEXT.environment' | translate }}</p>
  <p>{{ 'ASSESSMENTAPP.GUIDENESS_TEXT.goodLuck' | translate }}</p>
</div>